<template>
  <div :class="$style.container">
    <Row>
      <Item title="转出状态">
        <el-select v-model="status" placeholder="请选择状态">
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </Item>

      <Item title="域名">
        <el-input v-model="domainName" placeholder="请选择状态" />
      </Item>

      <Button type="primary" @click="submitSearch(1)"> 搜索 </Button>

      <Button @click="reset"> 重置 </Button>
    </Row>

    <Divider />

    <!-- 搜索列表 -->
    <Title title="转出列表" :count="total">
      <span :class="$style.title_tips">
        若您已在<span class="theme-color">新注册商接口</span>
        确认转入的前提下，请点击点“发送确认信”，发送转出确认邮件！
      </span>
    </Title>

    <el-table
      ref="multipleTable"
      :data="showList"
      :fit="true"
      border
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" width="50" align="center">
        <template slot-scope="scope">{{
          limit * (page - 1) + scope.$index + 1
        }}</template>
      </el-table-column>

      <el-table-column prop="name" label="域名" width="150" align="center" />

      <el-table-column
        prop="email"
        label="whois邮箱"
        width="120"
        align="center"
      />

      <el-table-column
        prop="createdTime"
        label="提交时间"
        width="100"
        align="center"
      />

      <el-table-column
        prop="transferStatus"
        label="转入状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          {{ getStatus(scope.row.transferStatus) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <div :class="$style.table_actions">
            <span
              :class="$style.btn"
              v-if="scope.row.status == 1"
              @click="checkStatus(scope.row.id, scope.row.domainName)"
            >
              查询转入状态
            </span>

            <template v-else-if="scope.row.status == 7">
              <span :class="$style.btn" @click="changeCode(scope.row)">
                修改转移码
              </span>
            </template>

            <span v-else class="normal-f">-</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="page"
      :page-size="limit"
      :total="total"
      @current-change="handlePageChange"
    />

    <!-- 修改转移码弹窗 -->
    <template v-if="codeVisible">
      <ChangeCodePopup
        :info="codeInfo"
        @close="setCodeVisible(false)"
        @success="submitSearch(1)"
      />
    </template>
  </div>
</template>

<script>
import {
  getTransferIntoList,
  getTransferIntoStatus,
  deleteTransferInto,
} from "@server";

import ChangeCodePopup from "./ChangeCodePopup.vue";

export default {
  name: "EnterRecord",
  components: { ChangeCodePopup },
  props: {
    type: {
      type: [Number, String],
      default: 0,
    },
  },
  watch: {
    type(value) {
      this.status = value;
      this.submitSearch();
    },
  },
  data() {
    return {
      statusList: [
        {
          value: 1,
          label: "转入中",
        },
        {
          value: 3,
          label: "过户中",
        },
        {
          value: 4,
          label: "转入成功",
        },
        {
          value: 5,
          label: "转入失败",
        },

        {
          value: 6,
          label: "转移码错误",
        },
      ],
      status: "",
      domainName: "",

      loading: false,
      page: 1,
      limit: 50,
      showList: [
        {
          status: 1,
        },
        {
          status: 7,
        },
      ],
      total: 0,

      // 修改转移码
      codeInfo: null,
      codeVisible: false,
    };
  },
  methods: {
    async submitSearch(page = 1) {
      this.loading = false;
      this.page = page;

      const params = {
        page: page,
        limit: this.limit,
      };
      this.status !== "" && (params.transferStatus = this.status);
      this.domainName !== "" && (params.name = this.domainName);

      const res = await getTransferIntoList(params);
      const { code, data } = res;
      if (code === 200) {
        this.total = data.total;
        this.showList = data.list;
      }
      this.loading = true;
    },
    reset() {
      this.status = "";
      this.domainName = "";
      this.submitSearch();
    },

    getStatus(status) {
      return this.statusList.find((i) => i.value === status)?.label || "-";
    },

    async checkStatus(id, dn) {
      this.loading = true;
      const res = await getTransferIntoStatus({ id });
      if (res.code == 200) {
        this.$alert(res.data, `${dn}转入状态`, {
          confirmButtonText: "确定",
        });
      }
      this.loading = false;
    },
    setCodeVisible(v) {
      this.codeVisible = v;
    },
    changeCode(item) {
      this.codeInfo = item;
      this.setCodeVisible(true);
    },

    handlePageChange(page) {
      this.submitSearch(page);
    },
  },
  created() {
    this.submitSearch();
  },
};
</script>

<style lang="scss" module scoped >
.container {
  min-height: 300px;

  :global {
    .gl-row {
      padding-bottom: rem(50);
    }

    ::v-deep .gl-item {
      margin-right: 40px;

      .gl-item__left {
        min-width: unset;
      }
    }

    .el-input {
      width: rem(330);
    }

    .el-pagination {
      margin: rem(50) 0;
      @include flex();
    }
  }

  .title_tips {
    font-size: rem(14);
    font-weight: normal;
    color: #666;
    margin-left: 20px;
  }

  .table_actions {
    @include flex();
    gap: rem(20);

    .btn {
      cursor: pointer;
      font-size: rem(14);
      color: $theme-color;
    }
  }
}
</style>
